/* eslint-disable react/jsx-key */
import {
  ActivteFiltersBar,
  SelectFiltersBar,
} from 'modules/shared-components/filters';
import useStrategiesState from '../../hooks/useStrategiesState';
import { MarketFilterTag, MarketFilter } from './market-filter';
import { TraderFilterTag, TraderFilter } from './trader-filter';
import { PairFilter, PairFilterTag } from './pair-filter';
import { ExchangeFilter, ExchangeFilterTag } from './exchange-filter';
import { MarketplaceSort } from './marketplace-sort';

export function StrategiesFilters() {
  const { filtersState, registerFilter, registerTag, registerSort } =
    useStrategiesState();

  return (
    <>
      <SelectFiltersBar sort={<MarketplaceSort {...registerSort()} />}>
        <ExchangeFilter {...registerFilter('exchangeId')} />
        <TraderFilter {...registerFilter('traderId')} />
        <MarketFilter {...registerFilter('market')} />
        <PairFilter {...registerFilter('symbolId')} />
      </SelectFiltersBar>
      <ActivteFiltersBar data-testid="active-filters">
        {filtersState.exchangeId.map((value) => (
          <ExchangeFilterTag {...registerTag('exchangeId', value)} />
        ))}
        {filtersState.traderId.map((value) => (
          <TraderFilterTag {...registerTag('traderId', value)} />
        ))}
        {filtersState.market.map((value) => (
          <MarketFilterTag {...registerTag('market', value)} />
        ))}
        {filtersState.symbolId.map((value) => (
          <PairFilterTag {...registerTag('symbolId', value)} />
        ))}
      </ActivteFiltersBar>
    </>
  );
}
